function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.65 1.281a1 1 0 011.39 0l9.655 9.333a1 1 0 010 1.438l-7.805 7.545a2.937 2.937 0 01-.95.615 2.989 2.989 0 01-2.222 0 2.937 2.937 0 01-.95-.615l-1.801-1.741-2.908 2.81 8.912 8.615a1 1 0 01-1.39 1.438l-9.641-9.32-.015-.013-9.655-9.334-.014-.013-.951-.92a1 1 0 011.39-1.438l.27.261 7.43-7.181a2.965 2.965 0 012.06-.828c.766 0 1.508.294 2.06.828l1.802 1.742L19.65 1.28zm.509 16.878l-1.753-1.694 1.693-1.637a6.125 6.125 0 001.265 3.44.956.956 0 01-.535.158.99.99 0 01-.367-.07.94.94 0 01-.303-.197zm2.666-1.28l5.737-5.546-8.217-7.942-2.589 2.503 5.043 4.875a.994.994 0 01.31.767.995.995 0 01-.204.564 4.098 4.098 0 00-.794 2.833c.067.697.314 1.366.714 1.946zm-9.7-12.68a.966.966 0 00-.67-.266c-.258 0-.498.1-.67.266l-7.38 7.134 8.215 7.943 8.05-7.782-7.545-7.295z",
  fill: "currentColor"
})));